import styled, { css } from 'styled-components';
import { PRIMARY_COLOR, SECONDARY_COLOR, SECONDARY_COLOR_2 } from '../../const/color';
import { FAMILY_FONT_CONTROL } from '../../const/text';
import { device } from '../../const/device';
import { EM_DEFAULT_FONTSIZE } from '../../const/sizes';

export const Container = styled.div<{checkCount: string}>`
  display: flex;
  justify-content: ${props => props.checkCount == "0" || props.checkCount == "3" ? 'space-between' : 'space-around'};
  
  @media (${device.tablet}) {
    justify-content: start;
  }
`;

export const GridContainer = styled.div`
  width: 100%;
  height: calc(100% - 80px);
  > div > div:first-child {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-auto-rows: max-content;
    grid-gap: 8px 8px;
  }
  @media (${device.tablet}) {
    height: auto;
    display: flex;
    overflow-y: hidden;
    overflow-x:scroll;
    padding-bottom: 20px;

    &::-webkit-scrollbar {
      height:3px;
    }

    &::-webkit-scrollbar-thumb {
      background:${SECONDARY_COLOR};
    }
  }
`;
export const ItemPattern = styled.div<{ preview: string, active: boolean }>`
  font-size: ${EM_DEFAULT_FONTSIZE}px;
  margin: 0 10px;
  //width: 128px;
  height: 190px;
  border-radius: 50%;
  position: relative;
  cursor: pointer;
  margin-top: 70px;
  
  &:before {
    content: '';
    background: url(${props => props.preview}) center no-repeat;
    background-size: contain;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    transform: scale(0.7);
  }
  
  &:hover {
    background-color: #F7F8FA;
  }
  
  ${props => props.active ? css`
    background-color: #F7F8FA;
    border-radius: 50%;
    border: 4px solid transparent;
    border-bottom: 4px solid rgb(16, 203, 165);
  ` : ''}
  
  &:active {
    transform: scale(1); 
  }
  @media (${device.tablet}) {
    height: 186px;
    width: 176px;
    flex: 0 0 auto;
  }
  @media (${device.mobileL}) {
    height: 96px;
    //width: 102px;
    //flex: 0 0 calc((100vw - 32px) / 4);
    flex: 0 0 96px;
  }
`;
export const CaruselMaskOpacity = styled.div`
    background: transparent;
    background-image: linear-gradient(to right, transparent,30%, #fefefe );
    opacity: 1;
    height: 30px;
    width: 12%;
    right: 30px;
    z-index: 10;
    position: absolute;
`

export const BottomMaskOpacity = styled.div<{theme: string}>`
    background: transparent;
    background-image: linear-gradient(
        to bottom,
        transparent 30%,
        ${props => props.theme === 'white' ? '#fefefe' : '#1A1A1A'} 70%
    );
    opacity: 1;
    z-index: 10;
    position: absolute;
    bottom: -32px;
    width: 100%;
    height: 90px;
`

export const TopMaskOpacity = styled.div<{theme: string}>`
    background: transparent;
    background-image: linear-gradient(
        to top,
        transparent 30%,
        ${props => props.theme === 'white' ? '#fefefe' : '#1A1A1A'} 70%
    );
    opacity: 1;
    z-index: 10;
    position: absolute;
    top: 100px;
    width: 100%;
    height: 90px;
`;

export const ItemCollar = styled.div<{ preview: string, active: boolean, themeColor: string }>`
  background: url(${props => props.preview}) top / 96px no-repeat;
  width: 96px;
  //height: 96px;
  background-clip: padding-box;
  padding-top: 96px;
  position: relative;
  text-align: center;
  font-family: ${FAMILY_FONT_CONTROL};
  color: ${SECONDARY_COLOR_2};
  cursor: pointer;

  &:after {
    content: '';
    position: absolute;
    width: 96px;
    height: 96px;
    top: 0;
    left: 0;
    border-radius: 50%;
    border: 4px solid transparent;
  }
  
  &:hover:after {
    border-bottom: 4px solid ${PRIMARY_COLOR};
  }
  
  ${props => props.active ? css`
    color: ${props.themeColor == "black" ? '#ffffff' : SECONDARY_COLOR};
    &:after {
      border-bottom: 4px solid ${PRIMARY_COLOR};
    }
  ` : ''}
  
  
  
  @media (${device.tablet}) {
    margin-right: 48px;
  }

  @media (${device.tabletS}) {
    margin-right: 25px;
  }
  
  @media (${device.mobileL}) {
    width: 64px;
    margin-right: auto;
    background: url(${props => props.preview}) top / 64px no-repeat;
    padding-top: ${64 + 8}px;
    &:last-child {
      margin-right: 0;
    }
    &:after {
      width: 64px;
      height: 64px;
    }
  }
`;

export const ItemSurface = styled.div<{ preview: string, active: boolean, themeColor: string }>`
  background: url(${props => props.preview}) top / 150px no-repeat;
  width: 150px;
  //height: 96px;
  background-clip: padding-box;
  padding-top: 160px;
  position: relative;
  text-align: center;
  font-family: ${FAMILY_FONT_CONTROL};
  color: ${SECONDARY_COLOR_2};
  cursor: pointer;

  &:after {
    content: '';
    position: absolute;
    width: 150px;
    height: 150px;
    top: 0;
    left: 0;
    border-radius: 50%;
    border: 4px solid transparent;
  }
  
  &:hover:after {
    border-bottom: 4px solid ${PRIMARY_COLOR};
  }
  
  ${props => props.active ? css`
    color: ${props.themeColor == "black" ? '#ffffff' : SECONDARY_COLOR};
    &:after {
      border-bottom: 4px solid ${PRIMARY_COLOR};
    }
  ` : ''}
  
  
  
  @media (${device.tablet}) {
    margin-right: 48px;
  }

  @media (${device.tabletS}) {
    margin-right: 25px;
  }
  
  @media (${device.mobileL}) {
    width: 64px;
    background: url(${props => props.preview}) top / 64px no-repeat;
    padding-top: ${64 + 8}px;
    &:last-child {
      margin-right: 0;
    }
    &:after {
      width: 64px;
      height: 64px;
    }
  }
`;
